import { PaymentMethodType } from "@wingspanhq/wingspan-api-sdk";
import { MethodType } from "../../modules/Settings/components/ManageMethods/types";

/**
 * Maps a v3 `PaymentMethodRef.type` onto the method type the app renders and
 * manages methods by.
 *
 * `ExternalBankAccount` and `Account` are the same instrument under two names —
 * v3 names the resource, the method UI names the category. The other two match.
 *
 * Returns `undefined` for a type the method UI cannot render, so a caller falls
 * back to an empty state rather than resolving the id against the wrong
 * resource (which 404s).
 */
export const selectorPaymentMethodRefMethodType = (
  paymentMethodType?: PaymentMethodType
): MethodType | undefined => {
  switch (paymentMethodType) {
    case PaymentMethodType.EXTERNAL_BANK_ACCOUNT:
      return "Account";

    case PaymentMethodType.INTERNAL_ACCOUNT:
      return "InternalAccount";

    case PaymentMethodType.PAYMENT_CARD:
      return "PaymentCard";

    default:
      return undefined;
  }
};
